// extracted by mini-css-extract-plugin
export default {"imageContainer":"q_-z","summaryPar":"r_-z","ratingCategories":"s_-z","reviewerInfo":"t_-z","reviewTypes":"u_-z","expanded":"v_-z"};